import React from "react";
import {
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Container,
  Paper,
} from "@mui/material";
import { departments } from './data';

const DepartmentsSection = () => {
  return (
    <Container sx={{ marginTop: 4, marginBottom: 6 }}>
      <Typography
        variant="h4"
        align="center"
        sx={{ fontWeight: "bold", color: "#228B22", marginBottom: 4 }}
      >
        Our Departments
      </Typography>
      
      <Grid container spacing={4}>
        {departments.map((department, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              elevation={3}
              sx={{
                borderRadius: 2,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: "transform 0.3s ease-in-out",
                "&:hover": {
                  transform: "scale(1.05)",
                  boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.2)",
                },
              }}
            >
              <CardMedia
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: 2,
                  backgroundColor: "#228B22",
                  color: "#fff",
                }}
              >
                {department.icon}
              </CardMedia>
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", color: "#228B22", marginBottom: 1 }}
                >
                  {department.name}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ marginBottom: 2 }}>
                  {department.description}
                </Typography>
                
                <Box sx={{ marginBottom: 2 }}>
                  <Typography variant="subtitle2" fontWeight="bold" sx={{ color: "#555" }}>
                    Key Metrics:
                  </Typography>
                  <Grid container spacing={1} sx={{ marginTop: 1 }}>
                    {Object.entries(department.metrics).map(([key, value], i) => (
                      <Grid item xs={6} key={i}>
                        <Paper 
                          elevation={1} 
                          sx={{ 
                            p: 1, 
                            textAlign: 'center',
                            backgroundColor: i % 2 === 0 ? '#f5f9f5' : '#eaf6ea'
                          }}
                        >
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                            {key.charAt(0).toUpperCase() + key.slice(1)}
                          </Typography>
                          <Typography variant="body2" fontWeight="bold">
                            {typeof value === 'number' && !key.includes('Rate') ? value : 
                             key === 'growthRate' || key === 'conversion' ? `${value}%` : 
                             key === 'satisfaction' || key === 'target' || key === 'efficiency' || key === 'accuracy' || key === 'compliance' || key === 'retention' ? `${value}%` : value}
                          </Typography>
                        </Paper>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default DepartmentsSection;